import {Component, inject, Input} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {CharityService} from "../../../services/charity.service";
import {GameService} from "../../../services/game.service";
import {ICharityWithContributionTotalsAndStripeStatus} from "../../../interfaces/charity/ICharityWithContributionTotalsAndStripeStatus";
import {StripeAccountType} from "../../../enum/StripeAccountType";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import { ICreateStripeAccountForCharity } from 'src/app/interfaces/charity/ICreateStripeAccountForCharity';
import { ErrorHandlingService } from 'src/app/services/error-handling.service';
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {StripeService} from "../../../services/stripe.service";
import {IStripeAccountQueryResult} from "../../../interfaces/stripe/IStripeAccountQueryResult";
import {PipesModule} from "../../../pipes/pipes.module";
import {ICreateStripeAccountLink} from "../../../interfaces/charity/ICreateStripeAccountLink";

@Component({
  selector: 'app-charity-stripe-settings',
  standalone: true,
  imports: [
    MatCardModule,
    MatButton,
    MatProgressSpinner,
    PipesModule
  ],
  templateUrl: './charity-stripe-settings.component.html',
  styleUrl: './charity-stripe-settings.component.css'
})
export class CharityStripeSettingsComponent {

  protected uiState = UIStateEnum.ShowData;
  protected readonly uiStateForTemplate = UIStateEnum;

  private charityService: CharityService = inject(CharityService)
  private stripeService: StripeService = inject(StripeService)
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);

  protected charity: ICharityWithContributionTotalsAndStripeStatus | undefined = this.charityService.activeCharity();
  protected game: IGameQueryResult | null = null;
  protected stripeAccount: IStripeAccountQueryResult | null = null;
  protected readonly StripeAccountType = StripeAccountType;

  @Input() set gameSetter(gameP: IGameQueryResult) {
    this.game = gameP;
  }

  constructor() {

    this.uiState = UIStateEnum.ShowLoading;

    this.stripeService.fetchStripeAccountForCharity(this.charity!.Id).subscribe({
      next: (resultP) => {
        this.stripeAccount = resultP;
        this.uiState = UIStateEnum.ShowData;
      },
      error: (error) => {
        this.errorHandlingService.displayPageLevelErrorMessage(error);
        this.uiState = UIStateEnum.ShowData;
      }
    });
  }

  protected onCreateStripeAccount() {
    this.uiState = UIStateEnum.ShowLoading;

    let createStripeAccountForCharityCommand: ICreateStripeAccountForCharity = {
      gameId: this.game != null ? this.game.Id : "",
      charityId: this.charity == null ? "" : this.charity.Id
    }

    this.stripeService.createStripeAccountForCharity(createStripeAccountForCharityCommand).subscribe({
      next:(resultP) => {
        if (this.charity != null) {
          this.charity.StripeAccountId = resultP.StripeAccountId;
          this.charity.StripeChargesEnabled = resultP.ChargesEnabled;
          this.charity.StripePayoutsEnabled = resultP.PayoutsEnabled;
        }
        this.uiState = UIStateEnum.ShowData;
      },
      error: (errorP) => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayDialogLevelErrorMessage(errorP, true);
      }
    })
  }

  protected onCompleteAccountSetup() {

    this.uiState = UIStateEnum.ShowLoading;

    let createStripeAccountLinkCommand: ICreateStripeAccountLink = {
      StripeAccountId: this.charity!.StripeAccountId,
      RefreshUrl: window.location.href,
      ReturnUrl: window.location.href
    };

    this.stripeService.generateStripeAccountLink(createStripeAccountLinkCommand).subscribe({
      next: (resultP) => {
        if (resultP.OnboardingLink) {
          window.location.href = resultP.OnboardingLink;
        }
      },
      error: (errorP) => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayDialogLevelErrorMessage(errorP, true);
      }
    });

  }

  protected stripeAccountHasRequirements() : boolean {
    return this.stripeAccount!.RequirementsPastDue.length > 0 ||
           this.stripeAccount!.RequirementsCurrentlyDue.length > 0 ||
           this.stripeAccount!.RequirementsEventuallyDue.length > 0;
  }
}
